/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Maja.Notifications.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { notificationsInstance } from '../../axios-instance';




export const getApiV1NotificationsUserId = (
    userId: string,
 signal?: AbortSignal
) => {


      return notificationsInstance<void>(
      {url: `/api/v1/notifications/${userId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1NotificationsUserIdQueryKey = (userId: string,) => {
    return [
    `/api/v1/notifications/${userId}`
    ] as const;
    }


export const getGetApiV1NotificationsUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1NotificationsUserIdQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>> = ({ signal }) => getApiV1NotificationsUserId(userId, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1NotificationsUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>>
export type GetApiV1NotificationsUserIdQueryError = unknown


export function useGetApiV1NotificationsUserId<TData = Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1NotificationsUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1NotificationsUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1NotificationsUserId<TData = Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1NotificationsUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1NotificationsUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1NotificationsUserId<TData = Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1NotificationsUserId<TData = Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1NotificationsUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1NotificationsUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const deleteApiV1NotificationsNotificationId = (
    notificationId: string,
 signal?: AbortSignal
) => {


      return notificationsInstance<void>(
      {url: `/api/v1/notifications/${notificationId}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteApiV1NotificationsNotificationIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>, TError,{notificationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['deleteApiV1NotificationsNotificationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  deleteApiV1NotificationsNotificationId(notificationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1NotificationsNotificationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>>

    export type DeleteApiV1NotificationsNotificationIdMutationError = unknown

    export const useDeleteApiV1NotificationsNotificationId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>, TError,{notificationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1NotificationsNotificationId>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getDeleteApiV1NotificationsNotificationIdMutationOptions(options), queryClient);
    }
